<template>
    <section class="bg-[#f9f9f9] py-20 px-4">
      <div class="max-w-6xl mx-auto text-center mb-16">
        <h2 class="text-2xl md:text-4xl font-bold mb-2">
            App Store da ICP
        </h2>
        <p class="text-sm text-gray-500">
            veja a lista de aplicativos já disponíveis em nosso app store!
        </p>
      </div>
  
      <div class="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
        <div
          v-for="(item, index) in vantagens"
          :key="index"
          class="bg-white rounded-2xl shadow p-6 text-center"
        >
          <div class="flex justify-center mb-4">
            <img :src="item.icone" :alt="item.titulo" class="w-40 h-40" />
          </div>
          <h3 class="font-bold text-lg mb-2">{{ item.titulo }}</h3>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const vantagens = [

 
    {
      titulo: 'PostgreSQL',
      icone: '/icones-apps/postgresql.svg'
    },
    {
      titulo: 'MySQL',
      icone: '/icones-apps/mysql.svg'
    },
    {
      titulo: 'WordPress',
      icone: '/icones-apps/wp.svg'
    },
    {
      titulo: 'PhpMyAdmin',
      icone: '/icones-apps/myadmin.svg'
    },
    {
      titulo: 'Tomcat',
      icone: '/icones-apps/tomcat.svg'
    },
    {
      titulo: 'Python',
      icone: '/icones-apps/python.svg'
    },
    {
      titulo: 'PHP',
      icone: '/icones-apps/php.svg'
    },
    {
      titulo: 'Node.js',
      icone: '/icones-apps/node.svg'
    },
    {
      titulo: 'Java',
      icone: '/icones-apps/java.svg'
    },
    {
      titulo: 'Go',
      icone: '/icones-apps/go.svg'
    },
    {
      titulo: 'PgAdmin4',
      icone: '/icones-apps/postgresql.svg'
    },
    {
      titulo: 'MongoBD',
      icone: '/icones-apps/mongo.svg'
    },
    {
      titulo: 'Redis',
      icone: '/icones-apps/redis.svg'
    },
    {
      titulo: 'SQL Server',
      icone: '/icones-apps/sql.svg'
    },
    {
      titulo: 'Ruby',
      icone: '/icones-apps/ruby.svg'
    },
    {
      titulo: 'Ruby on Rails',
      icone: '/icones-apps/ror.svg'
    },
    {
      titulo: 'Jetty',
      icone: '/icones-apps/jetty.svg'
    },
    {
      titulo: 'Wiki.js',
      icone: '/icones-apps/wiki.svg'
    },
    {
      titulo: 'MariaDB',
      icone: '/icones-apps/mariadb-icon.svg'
    }
   
   
   
   
  ]
  </script>
  